module.exports = "https://static.wmbcdn.com/uniweb/images/454a1a77f762e37107b5097e3c6cf00e.svg";